import styled from "styled-components";

export const IconButtonImage = styled.img`
  height: 70px;
  width: 70px;
  object-fit: cover;
`;
